import { Routes } from '@angular/router';

import { authChildGuard } from '@features/auth/guards';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@features/auth').then((m) => m.authRoutes),
  },
  {
    path: '',
    canActivateChild: [authChildGuard],
    loadComponent: () =>
      import('@layout/app-shell').then((m) => m.AppShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'student/dashboard',
      },
      {
        path: 'student',
        children: [
          {
            path: 'dashboard',
            loadChildren: () =>
              import('@features/dashboard').then((m) => m.dashboardRoutes),
          },
        ],
      },
      {
        path: 'dashboard',
        pathMatch: 'full',
        redirectTo: 'student/dashboard',
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('@features/profile').then((m) => m.profileRoutes),
      },
      {
        path: 'academic',
        loadChildren: () =>
          import('@features/academic').then((m) => m.academicRoutes),
      },
      {
        path: 'registration',
        loadChildren: () =>
          import('@features/registration').then((m) => m.registrationRoutes),
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('@features/finance').then((m) => m.financeRoutes),
      },
      {
        path: 'inbox',
        loadChildren: () =>
          import('@features/inbox').then((m) => m.inboxRoutes),
      },
      {
        path: '**',
        redirectTo: 'student/dashboard',
      },
    ],
  },
];
